document.addEventListener('rebuy:cart.add', function () {

    /* -------- UPDATE CART DRAWER -------- */
  fetch(`${routes.cart_url}?sections=cart-drawer&t=${Date.now()}`)
    .then((response) => response.json())
    .then((data) => {

      const parser = new DOMParser();
      const newHTML = parser.parseFromString(data['cart-drawer'], 'text/html');

      const selectors = [
        'cart-drawer-items',
        '.drawer__footer'
      ];

      selectors.forEach((selector) => {
        const currentElement = document.querySelector(selector);
        const newElement = newHTML.querySelector(selector);

        if (currentElement && newElement) {
          currentElement.replaceWith(newElement);
        }
      });

      // Remove empty state if exists
      document.querySelector('.drawer__inner-empty')?.remove();

      /* ------------------------------
         OPEN DRAWER PROPERLY (IMPORTANT)
      --------------------------------*/
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') {
          drawer.open();   // Dawn native open method
        } else {
          drawer.setAttribute('open', '');
        }
      }

    })
    .catch((error) => {
      console.error('Drawer update failed:', error);
    });


    /* -------- UPDATE HEADER CART COUNT -------- */
  fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {

      const count = cart.item_count;
      const icon = document.querySelector('#cart-icon-bubble');
      if (!icon) return;

      let bubble = icon.querySelector('.cart-count-bubble');

      if (count > 0) {

        if (!bubble) {
          icon.insertAdjacentHTML('beforeend', `
            <div class="cart-count-bubble">
              <span aria-hidden="true">${count}</span>
              <span class="visually-hidden">${count} items</span>
            </div>
          `);
        } else {
          const visible = bubble.querySelector('span[aria-hidden="true"]');
          const hidden = bubble.querySelector('.visually-hidden');

          if (visible) visible.textContent = count;
          if (hidden) hidden.textContent = `${count} items`;
        }

      } else {
        bubble?.remove();
      }

    })
    .catch((error) => {
      console.error('Cart bubble update failed:', error);
    });

});